import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-farm-dark border-t border-farm-green/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-12 items-center justify-center">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img
                src={require("../images/sahiwal-farms-logo.png")}
                alt="Sahiwal Farms"
                className="h-20 w-auto object-contain"
              />
            </div>
            <p className="text-farm-cream/70 mb-6">
              Excellence in dairy production and elite horse breeding since 1947.
            </p>
            <div className="flex gap-4">
              <motion.a
                whileHover={{ scale: 1.1, y: -2 }}
                href="https://www.facebook.com/people/Sahiwal-Farms/100070015893552/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-farm-green hover:bg-farm-gold rounded-full flex items-center justify-center text-farm-cream transition-colors duration-300"
              >
                <Facebook size={20} />
              </motion.a>

              {/* <motion.a
                whileHover={{ scale: 1.1, y: -2 }}
                href="#"
                className="w-10 h-10 bg-farm-green hover:bg-farm-gold rounded-full flex items-center justify-center text-farm-cream transition-colors duration-300"
              >
                <Instagram size={20} />
              </motion.a>

              <motion.a
                whileHover={{ scale: 1.1, y: -2 }}
                href="#"
                className="w-10 h-10 bg-farm-green hover:bg-farm-gold rounded-full flex items-center justify-center text-farm-cream transition-colors duration-300"
              >
                <Twitter size={20} />
              </motion.a> */}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-farm-cream mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {['Home', 'About', 'Services', 'Gallery', 'Contact'].map((link) => (
                <li key={link}>
                  <Link
                    to={`/${link.toLowerCase() === 'home' ? '' : link.toLowerCase()}`}
                    className="text-farm-cream/70 hover:text-farm-gold transition-colors duration-300"
                  >
                    {link}
                  </Link>
                </li>
              ))}
            </ul>
          </div>


          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold text-farm-cream mb-4">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <MapPin size={20} className="text-farm-gold mt-1 flex-shrink-0" />
                <span className="text-farm-cream/70">
                  Chak No# 134/9-L, Sahiwal,
                  <br />
                  Punjab, Pakistan
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={20} className="text-farm-gold flex-shrink-0" />
                <span className="text-farm-cream/70">+92 300 8698834
                  <br />+92 321 8698134</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail size={20} className="text-farm-gold flex-shrink-0" />
                <span className="text-farm-cream/70">sahiwalfarmss@gmail.com</span>
              </div>
            </div>
          </div>
        </div>


        {/* Bottom Bar */}
        <div className="border-t border-farm-green/20 pt-8 flex flex-col md:flex-row justify-center items-center gap-4">
          <p className="text-farm-cream/60 text-sm">
            © {currentYear} Sahiwal Farms. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
